import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
// Call the element loader before the bootstrapModule/bootstrapApplication call
defineCustomElements(window);
if (environment.production) {
  enableProdMode();
}
//console.time('AppLoadTime en main');

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  /* .then(() => {
    console.timeEnd('AppLoadTime en main'); // Aquí cierras la medición
  }) */
  .catch((err) => console.log(err));
